import { render, staticRenderFns } from "./order_multi.vue?vue&type=template&id=03cdcd74&scoped=true"
import script from "./order_multi.vue?vue&type=script&lang=js"
export * from "./order_multi.vue?vue&type=script&lang=js"
import style0 from "./order_multi.vue?vue&type=style&index=0&id=03cdcd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdcd74",
  null
  
)

export default component.exports